import { getSelectioAxios, setUser } from '@/main';

export default class UserProfileService {

    // --- NUOVI METODI ---

    /**
     * Recupera le info complete dell'utente (anagrafica + lista profili).
     */
    getUserInfo() {
        return getSelectioAxios().get('/iam/users/info', {
                headers: {
                    'x-application-code': 'selectio',
                },
            }).then(result => {
            return result.data;
        }).catch(e => {
            if (e.request && e.request.status === 403) {
                setUser(null);
            }
            throw e;
        });
    }

    // --- METODI ORIGINALI (Mantenuti per compatibilità) ---

    sendAction(action) {
        return getSelectioAxios().post('/sso/action/', action).then(result => {
            return result.data;
        }).catch(e => {
            if (e.request && e.request.status === 403) {
                setUser(null);
            }
            throw e;
        });
    }

    getProfile(username, role) {
        return getSelectioAxios().get('/sso/profile-by-user/' + username + '/role/' + role).then(result => {
            return result.data;
        }).catch(e => {
            if (e.request && e.request.status === 403) {
                setUser(null);
            }
            throw e;
        });
    }
}